export interface ListBoxSelectedIconProps {
  isSelected: boolean;
  disableAnimation?: boolean;
}

/* Icon for single select listbox items */
export function ListBoxSelectedIcon(props: ListBoxSelectedIconProps) {
  const { isSelected, disableAnimation } = props;

  return (
    <svg
      aria-hidden="true"
      data-selected={isSelected}
      role="presentation"
      viewBox="0 0 17 18"
      className="block"
    >
      <polyline
        fill="none"
        points="1 9 7 14 15 4"
        stroke="currentColor"
        strokeDasharray={22}
        strokeDashoffset={isSelected ? 44 : 66}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        style={
          !disableAnimation
            ? {
                transition: "stroke-dashoffset 200ms ease",
              }
            : {}
        }
      />
    </svg>
  );
}
